import { useSelector, useDispatch } from "react-redux";
import { setLegendVisibility, setSelectedPoint } from "../../store/pointsSlice";
import { formatCo2 } from "../../utils/co2";
import "./ObjectLegend.css";

const ICONS = `${process.env.PUBLIC_URL}/icons`;

const ObjectLegend = ({ setShowLeftPanel }) => {
    const dispatch = useDispatch();
    const selectedPoint = useSelector((state) => state.points.selectedPoint);
    const isVisible = useSelector((state) => state.points.isLegendVisible);
    const selectedYear = useSelector(
        (state) => state.points.selectedYear || "2030"
    );

    if (!selectedPoint || !isVisible) return null;

    const handleClose = () => {
        dispatch(setLegendVisibility(false));
        dispatch(setSelectedPoint(null));
    };

    const handleShowComposition = () => {
        setShowLeftPanel(true);
    };

    return (
        <div className="object-legend">
            <button className="close-button" onClick={handleClose}>
                ×
            </button>
            <h3>{selectedPoint.name}</h3>

            <div className="legend-summary">
                <p>
                    <img
                        className="legend-icon"
                        src={`${ICONS}/legend-mineral.svg`}
                        alt=""
                        aria-hidden="true"
                    /> Полезное ископаемое:{" "}
                    {selectedPoint.wasteType}
                </p>
                <p>
                    <img
                        className="legend-icon"
                        src={`${ICONS}/legend-waste.svg`}
                        alt=""
                        aria-hidden="true"
                    /> Количество отходов:{" "}
                    {Number(
                        selectedPoint.wasteByYear?.[selectedYear] ??
                            selectedPoint.wasteCount
                    )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                    тыс. т
                </p>
                <p>
                    <img
                        className="legend-icon"
                        src={`${ICONS}/legend-co2.svg`}
                        alt=""
                        aria-hidden="true"
                    /> Потенциал поглощения
                    CO₂ ({selectedYear}):{" "}
                    {formatCo2(selectedPoint.co2Absorption?.[selectedYear] ?? 0)}
                </p>
            </div>

            <button
                className="show-composition-button"
                onClick={handleShowComposition}
            >
                Посмотреть состав
            </button>
        </div>
    );
};

export default ObjectLegend;
